import { first, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers';

@Injectable()
export class SupportGuardService implements CanActivate {
  sport$: Observable<string>;

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router
  ) {
    this.sport$ = store.select(fromRoot.getSport);
  }

  canActivate(): Observable<boolean> {
    return this.sport$.pipe(
      map((sport) => {
        if (sport === 'soccer') {
          this.router.navigate(['/support/soccer']);
          return false;
        } else {
          this.router.navigate(['/support/football']);
          return false;
        }
      }),
      first()
    );
  }
}
